import CantileverTheme from 'styles/cantileverTheme'

export const INBOX_GRAY = CantileverTheme.colors.gray[400]
export const INBOX_CARD_GRAY = CantileverTheme.colors.grayscale[600]
export const INBOX_BORDER_GRAY = CantileverTheme.colors.grayscale[400]
export const INBOX_BORDER_GRAY_LOW_OPACITY = 'rgba(153,153,153,0.35)'
export const INBOX_INPUT_GRAY = 'rgba(70, 70, 70, 1)'
export const INBOX_TABLE_ROW_BACKGROUND = CantileverTheme.colors.grayscale[600]
export const INBOX_HEADER_COLOR = 'rgba(72, 72, 72, 1)'
export const INBOX_HIGHLIGHT_COLOR = CantileverTheme.colors.blue['500_base']
export const INBOX_DARK_BACKGROUND = 'rgba(55, 55, 55, 1)'
export const INBOX_DARKER_BACKGROUND = 'rgba(45, 45, 45, 1)'
